export default "__VITE_ASSET__DN0ALH8Y__"